module.exports = __webpack_public_path__ + "img/saxophone.be5030ca.webp";